module.exports = __webpack_public_path__ + "img/home-swiper-zibinyuan.68b0e554.jpg";